export const QUERY_KEYS = {
  aiTracks: 'aiTracks',
  account: 'account',
  accountUser: 'accountUser',
  accountStatus: 'accountStatus',
  walletUser: 'walletUser',
  walletAccount: 'walletAccount',
  walletAddresses: 'walletAddresses',
  trackCommentList: 'trackCommentList',
  userCommentList: 'userCommentList',
  comment: 'comment',
  commentReplies: 'commentReplies',
  computedProps: 'computedProps',
  downloadTrackStems: 'downloadTrackStems',
  stemsArchiveJob: 'stemsArchiveJob',
  exploreContent: 'exploreContent',
  trackCommentNotificationSetting: 'trackCommentNotificationSetting',
  trackCommentCount: 'trackCommentCount',
  trackDownloadCounts: 'trackDownloadCounts',
  track: 'track',
  tracksByUser: 'tracksByUser',
  tracksByHandle: 'tracksByHandle',
  trackByPermalink: 'trackByPermalink',
  tracksByPlaylist: 'tracksByPlaylist',
  tracksByAlbum: 'tracksByAlbum',
  trackFileInfo: 'trackFileInfo',
  stems: 'stems',
  user: 'user',
  userByHandle: 'userByHandle',
  userTracksByHandle: 'userTracksByHandle',
  userPlaylists: 'userPlaylists',
  userAlbums: 'userAlbums',
  userTracksDownloadCount: 'userTracksDownloadCount',
  collection: 'collection',
  collections: 'collections',
  collectionByPermalink: 'collectionByPermalink',
  followers: 'followers',
  favoritedTracks: 'favoritedTracks',
  relatedArtists: 'relatedArtists',
  rootWalletAddress: 'rootWalletAddress',
  mintRecovery: 'mintRecovery',
  purchases: 'purchases',
  purchasesCount: 'purchasesCount',
  sales: 'sales',
  salesCount: 'salesCount',
  mutualFollowers: 'mutualFollowers',
  emailInUse: 'emailInUse',
  handleInUse: 'handleInUse',
  handleReservedStatus: 'handleReservedStatus',
  search: 'search',
  trending: 'trending',
  suggestedArtists: 'suggestedArtists',
  topArtistsInGenre: 'topArtistsInGenre',
  audioTransactions: 'audioTransactions',
  audioTransactionsCount: 'audioTransactionsCount',
  libraryCollections: 'libraryCollections',
  favorites: 'favorites',
  following: 'following',
  notifications: 'notifications',
  notificationUnreadCount: 'notificationUnreadCount',
  reposts: 'reposts',
  remixers: 'remixers',
  remixersCount: 'remixersCount',
  trackHistory: 'trackHistory',
  topTags: 'topTags',
  feed: 'feed',
  authorizedApps: 'authorizedApps',
  developerApps: 'developerApps',
  searchAutocomplete: 'searchAutocomplete',
  purchasers: 'purchasers',
  purchasersCount: 'purchasersCount',
  remixedTracks: 'remixedTracks',
  recommendedTracks: 'recommendedTracks',
  mutedUsers: 'mutedUsers',
  salesAggregate: 'salesAggregate',
  usdcTransactionsCount: 'usdcTransactionsCount',
  usdcTransactions: 'usdcTransactions',
  libraryTracks: 'libraryTracks',
  remixes: 'remixes',
  premiumTracks: 'premiumTracks',
  profileReposts: 'profileReposts',
  profileTracks: 'profileTracks',
  trendingIds: 'trendingIds',
  trendingUnderground: 'trendingUnderground',
  trendingWinners: 'trendingWinners',
  trendingAlbums: 'trendingAlbums',
  newReleaseAlbums: 'newReleaseAlbums',
  bestSellingAlbums: 'bestSellingAlbums',
  trackPageLineup: 'trackPageLineup',
  connectedWallets: 'connectedWallets',
  audioBalance: 'audioBalance',
  userCoinBalance: 'userCoinBalance',
  events: 'events',
  eventsByEntityId: 'eventsByEntityId',
  remixContestsList: 'remixContestsList',
  walletOwner: 'walletOwner',
  tokenPrice: 'tokenPrice',
  usdcBalance: 'usdcBalance',
  destinationUsdcAccount: 'destinationUsdcAccount',
  rootWalletUsdcAccount: 'rootWalletUsdcAccount',
  fileSizes: 'fileSizes',
  sendTokens: 'sendTokens',
  managedAccounts: 'managedAccounts',
  userManagers: 'userManagers',
  feelingLuckyTracks: 'feelingLuckyTracks',
  recentlyPlayedTracks: 'recentlyPlayedTracks',
  recentlyCommentedTracks: 'recentlyCommentedTracks',
  fanClubMembers: 'fanClubMembers',
  coins: 'coins',
  userCreatedCoins: 'userCreatedCoins',
  userCoins: 'userCoins',
  walletCoins: 'walletCoins',
  coin: 'coin',
  discordCode: 'discordCode',
  coinInsights: 'coinInsights',
  fanClub: 'fanClub',
  fanClubByMint: 'fanClubByMint',
  userCoin: 'userCoin',
  fanClubHoldersCount: 'fanClubHoldersCount',
  fanClubMembersCount: 'fanClubMembersCount',
  coinByTicker: 'coinByTicker',
  userbank: 'userbank',
  tokenExchangeRate: 'tokenExchangeRate',
  tokenPair: 'tokenPair',
  firstBuyQuote: 'firstBuyQuote',
  walletSolBalance: 'walletSolBalance',
  launchpadConfig: 'launchpadConfig',
  externalWalletBalance: 'externalWalletBalance',
  claimFee: 'claimFee',
  userBalanceHistory: 'userBalanceHistory',
  exclusiveTracks: 'exclusiveTracks',
  exclusiveTracksCount: 'exclusiveTracksCount',
  coinRedeemAmount: 'coinRedeemAmount',
  coinRedeemCodeAmount: 'coinRedeemCodeAmount',
  uploadStatus: 'uploadStatus',
  fanClubFeed: 'fanClubFeed',
  eventComments: 'eventComments',
  eventFollowState: 'eventFollowState',
  eventFollowers: 'eventFollowers'
} as const
